import React from 'react';
import classNames from 'classnames';

import s from './styles.module.scss';

interface IPrivateProps {
  children?: React.ReactNode;
}

export interface IBaseInputLabelProps {
  label: string;
  position?: 'left' | 'top';
}

type IProps = IBaseInputLabelProps & IPrivateProps;

const BaseInputLabel: React.FC<IProps> = ({
  label,
  position = 'top',
  children,
}) => {
  return (
    <div
      className={classNames(s.wrapper, {
        [s.left]: position === 'left',
        [s.top]: position === 'top',
      })}
    >
      <label className={s.label}>{`${label}:`}</label>
      <div className={s.content}>{children}</div>
    </div>
  );
};

export default BaseInputLabel;
